const state = {
    nodeMap: new Map(),
    isEdit: null,
    selectedNode: {},
    selectFormItem: null,
    design: {},
    selectForm: null,
    FormList: [],
    buildinfo: {
        fromBillID: '',
        fromBillCode: '',
        fromBillKey: '',
        fromInfo: null,
        formRow: null,
    },
    workitem: null,
}

const mutations = {
    selectedNode(state, val) {
        state.selectedNode = val
    },
    loadForm(state, val) {
        state.design = val
    },
    setIsEdit(state, val) {
        state.isEdit = val
    },
    setSelectForm(state, val) {
        state.selectForm = val
    },
    setFormList(state, val) {
        state.FormList = val
    },
    setBuildInfo(state, val) {
        state.buildinfo = val
    },
    setWorkItem(state, val) {
        state.workitem = val
    },
}

const actions = {
    setIsEdit: ({ commit }, val) => {
        commit('setIsEdit', val)
    },
    loadForm: ({ commit }, val) => {
        commit('loadForm', val)
    },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
